import { init } from "./start";
import { TaskType } from "@/types/index";
import { ref } from "vue";

import startNodeBgIcon from "@/assets/icons/start-node-bg.svg";
import startNode from "@/assets/icons/start-node.svg";
import switchNodeBgIcon from "@/assets/icons/switch-node-bg.svg";
import switchNodeIcon from "@/assets/icons/switch-node.svg";

import replyMessageBg from "@/assets/icons/reply-message-bg.svg";
import replyMessage from "@/assets/icons/reply-message.svg";

import branchOptionsBg from "@/assets/icons/branch-options-bg.svg";
import branchOptions from "@/assets/icons/branch-options.svg";

import callAPIBg from "@/assets/icons/call-api-bg.svg";
import callAPI from "@/assets/icons/call-api.svg";

import collectMessageBg from "@/assets/icons/collect-message-bg.svg";
import collectMessage from "@/assets/icons/call-api.svg";

import transferToManualBg from "@/assets/icons/transfer-to-manual-bg.svg";
import transferToManual from "@/assets/icons/transfer-to-manual.svg";

import transFlowBg from "@/assets/icons/trans-flow-bg.svg";

import nodeCopyIcon from "@/assets/icons/copy-node-icon.svg";
import deleteNodeIcon from "@/assets/icons/delete-node-icon.svg";
import editNodeIcon from "@/assets/icons/edit-node-icon.svg";

import deleteEdgeIcon from "@/assets/icons/delete-edge-icon.svg";

import nodeErrorIcon from "@/assets/icons/node-error-icon.svg";
import { get, find } from "lodash-es";
import { getRelationUUID, getUUID } from "./utils";
import { ComponentPublicInstance } from "vue";

// 导入 富文本编辑器样式
import "quill/dist/quill.snow.css";
import { t } from "./utils/i18n";
import { AskMode } from "./types/infoExtractNodeType";
import { ReplyMode } from "./types/endReplyNodeType";
import {
  BranchMode,
  ConditionMode,
  MatchMode,
  JudgeType,
} from "./types/conditionJudgeNodeType";
import { FALLBACK_SUCCESS } from "./components/const";

const buttonIconMaps = {
  copy: nodeCopyIcon,
  delete: deleteNodeIcon,
  edit: editNodeIcon,
  error: nodeErrorIcon,
};

export { TaskType } from "./types";

export const getNodeList = (taskType) => {
  if (taskType === TaskType.AGENT) {
    return getAgentNodeList();
  }
  return getNormalNodeList();
};

export const getNormalNodeList = () => {
  return [
    {
      type: "startNode",
      name: t("启动节点"),
      icon: startNodeBgIcon,
      pIcon: startNode,
      bgColor: "#00BDA4",
      width: 50,
      height: 50,
      group: t("启动节点"),
      hidden: true,
      // 以下是一些节点样式配置
      styles: {
        icon: startNodeBgIcon,
        // 主方块尺寸
        nodeStyle: {
          fill: "#00BDA4",
        },
        // 中心点图标尺寸
        iconStyle: {
          width: 28,
          height: 28,
        },
        // 链接点样式
        bulletStyle: {
          stroke: "#00BDA4",
          fill: "#00BDA4",
        },
        buttonIconMaps,
      },
    },
    {
      type: "conditionalBranchNode",
      icon: switchNodeBgIcon,
      name: t("条件判断"),
      group: t("判断节点"),
      canEditRelation: true,
      styles: {
        icon: switchNodeBgIcon,
        nodeStyle: {
          fill: "#6F4ADD",
        },
        iconStyle: {
          width: 28,
          height: 28,
        },
        bulletStyle: {
          lineWidth: 0,
          stroke: "#6F4ADD",
          fill: "#6F4ADD",
        },
        buttonIconMaps,
      },
    },
    {
      type: "replyMessageNode",
      icon: replyMessageBg,
      name: t("回复消息"),
      group: t("动作节点"),
      styles: {
        icon: replyMessageBg,
        nodeStyle: {
          fill: "#1F69E5",
        },
        // 可连线区热点区样式
        bulletStyle: {
          stroke: "#1F69E5",
          fill: "#1F69E5",
        },
        buttonIconMaps,
      },
    },
    {
      type: "branchNode",
      icon: branchOptionsBg,
      name: t("分支选项"),
      group: t("动作节点"),
      canEditRelation: true,
      styles: {
        icon: branchOptionsBg,
        nodeStyle: {
          fill: "#1F69E5",
        },
        // 可连线区热点区样式
        bulletStyle: {
          stroke: "#1F69E5",
          fill: "#1F69E5",
        },
        buttonIconMaps,
      },
    },
    {
      type: "interfaceInvocationNode",
      icon: callAPIBg,
      name: t("接口调用"),
      group: t("动作节点"),
      styles: {
        icon: callAPIBg,
        nodeStyle: {
          fill: "#1F69E5",
        },
        // 可连线区热点区样式
        bulletStyle: {
          stroke: "#1F69E5",
          fill: "#1F69E5",
        },
        buttonIconMaps,
      },
    },
    {
      type: "formSaveNode",
      icon: collectMessageBg,
      name: t("信息收集"),
      group: t("动作节点"),
      styles: {
        icon: collectMessageBg,
        nodeStyle: {
          fill: "#1F69E5",
        },
        // 可连线区热点区样式
        bulletStyle: {
          stroke: "#1F69E5",
          fill: "#1F69E5",
        },
        buttonIconMaps,
      },
    },
    {
      type: "transToHumanNode",
      icon: transferToManualBg,
      name: t("转人工"),
      group: t("跳转节点"),
      styles: {
        icon: transferToManualBg,
        nodeStyle: {
          fill: "#1F69E5",
        },
        // 可连线区热点区样式
        bulletStyle: {
          stroke: "#1F69E5",
          fill: "#1F69E5",
        },
        buttonIconMaps,
      },
    },
    {
      type: "transToTaskNode",
      icon: transFlowBg,
      name: t("转任务流"),
      group: t("跳转节点"),
      styles: {
        icon: transFlowBg,
        nodeStyle: {
          fill: "#1F69E5",
        },
        // 可连线区热点区样式
        bulletStyle: {
          stroke: "#1F69E5",
          fill: "#1F69E5",
        },
        buttonIconMaps,
      },
    },
  ];
};

export const getAgentNodeList = () => {
  return [
    {
      type: "userIntentNode",
      name: t("启动节点"),
      bgColor: "#00BDA4",
      icon: startNodeBgIcon,
      width: 50,
      height: 50,
      group: t("启动节点"),
      hidden: true,
      styles: {
        icon: startNodeBgIcon,
        nodeStyle: {
          fill: "#00BDA4",
        },
        iconStyle: {
          width: 28,
          height: 28,
        },
        bulletStyle: {
          stroke: "#00BDA4",
          fill: "#00BDA4",
        },
        buttonIconMaps,
      },
    },
    {
      type: "conditionJudgeNode",
      icon: switchNodeBgIcon,
      name: t("条件判断"),
      group: t("判断节点"),
      canEditRelation: true,
      styles: {
        icon: switchNodeBgIcon,
        nodeStyle: {
          fill: "#6F4ADD",
        },
        iconStyle: {
          width: 28,
          height: 28,
        },
        bulletStyle: {
          lineWidth: 0,
          stroke: "#6F4ADD",
          fill: "#6F4ADD",
        },
        buttonIconMaps,
      },
    },
    {
      type: "infoExtractNode",
      icon: collectMessageBg,
      name: t("信息收集"),
      group: t("动作节点"),
      styles: {
        icon: collectMessageBg,
        nodeStyle: {
          fill: "#1F69E5",
        },
        bulletStyle: {
          stroke: "#1F69E5",
          fill: "#1F69E5",
        },
        buttonIconMaps,
      },
    },
    {
      type: "interfaceInvocationNode",
      icon: callAPIBg,
      name: t("接口调用"),
      group: t("动作节点"),
      styles: {
        icon: callAPIBg,
        nodeStyle: {
          fill: "#1F69E5",
        },
        // 可连线区热点区样式
        bulletStyle: {
          stroke: "#1F69E5",
          fill: "#1F69E5",
        },
        buttonIconMaps,
      },
    },
    {
      type: "endReplyNode",
      icon: replyMessageBg,
      name: t("结束回复"),
      group: t("动作节点"),
      styles: {
        icon: replyMessageBg,
        nodeStyle: {
          fill: "#1F69E5",
        },
        bulletStyle: {
          stroke: "#1F69E5",
          fill: "#1F69E5",
        },
        buttonIconMaps,
      },
    },
  ];
};

const getAgentNodeTypeDefaultData = (nodeType: string) => {
  switch (nodeType) {
    case "conditionJudgeNode":
      return {
        matchMode: MatchMode.AI, // 1: AI模式; 2: 规则模式
        branches: [
          {
            id: getRelationUUID(),
            name: "条件组1",
            content: "条件组1", // 兼容旧数据
            mode: BranchMode.AI, // 0: 智能模式; 1: and(多个条件and满足) ; 2: or(多个条件或满足); 3: else(兜底分支)
            conditions: [
              {
                type: JudgeType.INFO, // 1: 提取的信息; 2: 系统变量; 3: 自定义变量
                info_id: "", // 待判断值，信息词槽id或变量名
                mode: ConditionMode.EQUAL, // 1: 包含; 2: 不包含; 3: 等于; 4: 不等于; 5: 为空; 6: 不为空
                content: "", // 信息值匹配列表
              },
            ],
          },
          {
            id: getRelationUUID(),
            name: "其他",
            content: "其他",
            mode: BranchMode.ELSE,
            conditions: [
              {
                content: "",
              },
            ],
          },
        ],
      };
    case "endReplyNode":
      return {
        mode: ReplyMode.KNOWLEDGE,
        content: "",
      };
    case "infoExtractNode":
      return {
        infos: [
          {
            id: `info-${getUUID()}`,
            name: "",
            en_name: "",
            desc: "",
            required: true,
            askMode: AskMode.AI,
          },
        ],
      };
    case "interfaceInvocationNode":
      // 智能任务流使用新格式
      return {
        url: "",
        callbackTimeout: 4500,
        params: [
          {
            type: 1,
            key: "",
            value: "",
          },
        ],
        returns: [
          {
            info_id: "",
            key: "",
          },
        ],
        fallbackSwitch: 0,
        async: false,
        authType: 0,
        basicAuth: {
          basicToken: "",
        },
        bearerAuth: {
          bearerToken: "",
        },
        customAuth: {
          key: "",
          value: "",
        },
        branches: [
          {
            id: getRelationUUID(),
            content: t("调用成功"),
            type: FALLBACK_SUCCESS,
          },
        ],
      };
  }
};

const getNormalNodeTypeDefaultData = (nodeType: string) => {
  console.log(nodeType);
  if (nodeType === "conditionalBranchNode") {
    return {
      branches: [
        {
          id: getRelationUUID(),
          type: 1,
          content: "",
          condition: [
            {
              relation: "==",
              variableKey: "",
              value: "",
            },
          ],
        },
      ],
    };
  }
  if (nodeType === "interfaceInvocationNode") {
    return {
      url: "",
      request: {
        body: [
          {
            varType: 1,
            key: "",
            valueType: "string",
          },
        ],
      },
      response: {
        body: [
          {
            varType: 1,
            key: "",
            valueType: "string",
          },
        ],
      },
    };
  }
  if (nodeType === "branchNode") {
    return {
      branches: [
        {
          id: getRelationUUID(),
          content: "",
        },
      ],
    };
  }
  // if (nodeType === "CallAPI") {
  //   return {
  //     branches: [
  //       {
  //         id: getRelationUUID(),
  //         content: "成功",
  //       },
  //       {
  //         id: getRelationUUID(),
  //         content: "失败",
  //       },
  //     ],
  //   };
  // }
  if (nodeType === "transToHumanNode") {
    return {
      routePolicy: "0",
    };
  }
  if (nodeType === "formSaveNode") {
    return {
      skipWhenAllVariablesExist: false,
      inputVariables: [
        {
          type: "string",
          name: "",
          placeholder: "",
          isRequired: 0, // 1:必填, 0非必填
          variableKey: "", // 从变量列表拉取，再选择
          formType: 1,
          chooseItemList: [""],
        },
      ],
    };
  }
};

export const xGraph = (selector: string, type: TaskType) => {
  const startNodeType =
    type === TaskType.AGENT ? "userIntentNode" : "startNode";
  const app = init(
    {
      node: {
        nodeList: getNodeList(type),
        createNodeBehavior: {
          getNodeTypeDefaultData(nodeType: string) {
            if (type === TaskType.AGENT) {
              return getAgentNodeTypeDefaultData(nodeType);
            }
            return getNormalNodeTypeDefaultData(nodeType);
          },
        },
        startNodeType,
      },
      edge: {
        // 给 edge hover 时候的 button 配置的样式
        deleteEdgeBehavior: {
          iconMaps: {
            // 可以是网络图片
            delete: deleteEdgeIcon,
          },
        },
        createEdgeBehavior: {
          // 返回是否可完成连线
          calcShouldEnd(e: any, cEdge: any, graph) {
            console.log("===============");
            const { item, x, y } = e;
            const itemType = item.getType();
            if (itemType === "node" && cEdge) {
              const itemModel = item.getModel();
              // 终点不可以是开始节点
              if (itemModel.type === "start-node") {
                return false;
              }

              // 结束点不可以是自己
              const source = cEdge.getSource();
              if (source === item) {
                console.log("TIP: 结束不可以是自己");
                return false;
              }

              const sourceModel = source.getModel();

              // 起始点不能有多个 edge
              if (sourceModel.type === "start-node") {
                if (source.getEdges().length > 1) {
                  return false;
                }
              }

              // 转人工节点暂不支持出口
              const {
                nodeData: { nodeType },
              } = sourceModel;
              if (
                [
                  "transToHumanNode",
                  "endReplyNode",
                  "transToTaskNode",
                ].includes(nodeType)
              ) {
                return false;
              }

              const sourceNodeType = sourceModel.nodeData.nodeType;
              const sourceEdges = source.getEdges();

              if (
                [
                  "conditionalBranchNode",
                  "branchNode",
                  "conditionJudgeNode",
                ].includes(sourceNodeType)
              ) {
                const sourceOutEdges = source.getOutEdges();
                const branches = sourceModel.nodeData.branches || [];
                const relationListLength = get(branches, "length", 0);

                if (relationListLength === 0) {
                  return false;
                }

                const usedIds = sourceOutEdges
                  .map((edge: any) => {
                    return edge.getModel()?.edgeData?.branchId;
                  })
                  .filter((v: string | undefined | null) => {
                    if (v && cEdge.getModel()?.edgeData?.branchId !== v) {
                      return true;
                    }
                  });

                const relationIdList = branches.map(
                  (v: { id: string }) => v.id,
                );

                if (
                  relationIdList.every((id: string) => usedIds.includes(id))
                ) {
                  return false;
                }
              }

              if (
                [
                  "replyMessageNode",
                  "formSaveNode",
                  "infoExtractNode",
                ].includes(sourceNodeType)
              ) {
                const sourceOutEdges = source.getOutEdges();
                // 这个类型不允许多条出口
                const diffEdges = sourceOutEdges.filter(
                  (v: any) => v !== cEdge,
                );
                if (diffEdges.length > 0) {
                  return false;
                }
              }

              // 接口调用节点，如果没有打开异常处理，则不允许有多条出口
              if (
                "interfaceInvocationNode" === sourceNodeType &&
                !sourceModel.nodeData.fallbackSwitch
              ) {
                const sourceOutEdges = source.getOutEdges();
                const diffEdges = sourceOutEdges.filter(
                  (v: any) => v !== cEdge,
                );
                if (diffEdges.length > 0) {
                  return false;
                }
              }

              // 根据类型判断反方向连线
              const existing = sourceEdges.find((edge: any) => {
                if (edge === cEdge) {
                  //此 edge 是当前 edge
                  return false;
                }
                const target = edge.getTarget();
                const source = edge.getSource();
                if (target === item) {
                  // 不允许相同的 source target
                  return true;
                }
                // 允许 A->B , B->A 的量子缠绕环形
                if (source === item) {
                  // return true;
                  return false;
                }
              });
              if (existing) {
                return false;
              }
              return true;
            }
            // 80以内自动吸附
            if (itemType === "edge" && cEdge) {
              const nodes = graph.getNodes();
              const extNodes = nodes.filter((node) => {
                return (
                  get(node.getModel(), "nodeData.nodeType") !== startNodeType
                );
              });
              if (!extNodes.length) {
                return false;
              }
              let closestNode = null;
              let minDistance = Infinity;
              extNodes.forEach((node) => {
                const model = node.getModel();
                const distance = Math.sqrt(
                  (model.x - x) ** 2 + (model.y - y) ** 2,
                );
                // 80 是吸附的阈值
                if (distance < minDistance && distance < 80) {
                  minDistance = distance;
                  closestNode = node;
                }
              });

              if (closestNode) {
                e.item = closestNode;
                return true;
              }
            }
            return false;
          },
          // 返回 edge 的配置 ，
          getEdgeConfig(edgeCfg: any, self: any, type: string) {
            // 获取 node 的类型
            if (type === "createEnd") {
              const edge = self.edge;
              const source = edge.getSource();
              const sourceModel = source.getModel();
              const sourceNodeType = sourceModel.nodeData.nodeType;
              console.log(sourceNodeType);

              // branchNode conditionalBranchNode
              if (
                [
                  "branchNode",
                  "conditionalBranchNode",
                  "conditionJudgeNode",
                  "interfaceInvocationNode",
                ].includes(sourceNodeType)
              ) {
                // 如果边的 branchId 已经有了，则直接跳过
                if (edge.getModel()?.edgeData?.branchId) {
                  return {};
                }

                // 挑选一条没有使用过的 条件组
                const branches = sourceModel.nodeData.branches;
                const sourceOutEdges = source.getOutEdges();

                const usedRelationIdList = sourceOutEdges
                  .map((edge: any) => {
                    return edge.getModel()?.edgeData?.branchId;
                  })
                  .filter((v: any) => v);

                const relation = find(branches, (v: { id: any }) => {
                  return !usedRelationIdList.includes(v.id);
                });

                if (relation) {
                  return {
                    label: relation.content + " ▼",
                    isFallback: relation.type,
                    edgeData: {
                      branchId: relation.id,
                      data: {},
                    },
                  };
                }
              }
            }
          },
        },
      },
      g6Config: {},
      // minimap: {
      //   size: [200, 200],
      // },
    },
    type,
  );

  app.mount(selector);
  // _container._vnode.component.proxy
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const appInstance = app?._container._vnode.component
    .proxy as ComponentPublicInstance<
    any,
    any,
    any,
    any,
    {
      addEvent: (fn: (type: string, payload: any) => any) => void;
      readData: (jsonData: string) => void;
      setMaxLimits: (params: { maxAnswerLength: number }) => void;
      setGroups: (params: Array<{ value: string; label: string }>) => void;
      handleSave: (params) => void;
      addUploadEvent: (fn) => Promise<any>;
      addGetGroupsEvent: (fn) => Promise<any>;
      getTaskFlows: (fn) => Promise<any>;
      getTaskTriggerEventIds: (fn) => Promise<any>;
      changeLanguage: (lang: "zh" | "en") => void;
    }
  >;
  return appInstance;
};
